import { AuthenticationEvents } from "@teaming/common-enums";

export default function authPluginFactory( authService ) {
	return {
		install( app ) {
			app.config.globalProperties.$auth = authService;

			app.mixin( {
				created() {
					if ( this.handleLoginEvent ) {
						authService.addListener( AuthenticationEvents.LOGIN, this.handleLoginEvent );
						authService.addListener( AuthenticationEvents.SIGNUP, this.handleLoginEvent );
					}
					if ( this.handleLoginError ) {
						authService.addListener( AuthenticationEvents.LOGIN_ERROR, this.handleLoginError );
						authService.addListener( AuthenticationEvents.SIGNUP_ERROR, this.handleLoginError );
					}
				},

				unmounted() {
					if ( this.handleLoginEvent ) {
						authService.removeListener( AuthenticationEvents.LOGIN, this.handleLoginEvent );
						authService.removeListener( AuthenticationEvents.SIGNUP, this.handleLoginEvent );
					}
					if ( this.handleLoginError ) {
						authService.removeListener( AuthenticationEvents.LOGIN_ERROR, this.handleLoginError );
						authService.removeListener( AuthenticationEvents.SIGNUP_ERROR, this.handleLoginError );
					}
				},
			} );
		},
	};
}
